






















































































import { Vue, Prop, Component } from "vue-property-decorator";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import { AgentReportsPaymentParams } from "@/services/agent-reports";
import { getCurrentCompanyId } from "@/plugins/roles";
import CustomButton from "@/components/form/CustomButton.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { AgentListClass } from "@/classes/list/AgentListClass";
import { ContractorsListClass } from "@/classes/list/ContractorsListClass";
import { EmployeesListClass } from "@/classes/list/EmployeesListClass";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";

@Component({
  components: { CustomDatepicker, CSingleSelect, CustomButton, CBlock }
})
export default class AgentPaymentFilter extends Vue {
  @Prop({ default: false }) isLoading?: boolean;
  agentList: AgentListClass = new AgentListClass();
  contractorList: ContractorsListClass = new ContractorsListClass();
  employeesList = new EmployeesListClass({
    id: this.companyId
  });
  params: AgentReportsPaymentParams = {
    agentId: undefined,
    companyId: this.companyId,
    contractorId: undefined,
    responsibleId: undefined,
    paidToAgent: undefined,
    paymentAtMin: undefined,
    paymentAtMax: undefined
  };

  get companyId() {
    return getCurrentCompanyId();
  }

  applyFilter() {
    this.$emit("applyFilter", this.params);
  }

  clearFilter() {
    this.params.responsibleId = undefined;
    this.params.agentId = undefined;
    this.params.contractorId = undefined;
    this.params.paidToAgent = undefined;
    this.params.paymentAtMin = undefined;
    this.params.paymentAtMax = undefined;
    this.$emit("clearFilter", this.params);
  }
}
